
<app-breadcrumb [title]="'Exámenes Médicos'" [items]="['Personas']" [active_item]="'Exámenes Médicos'"></app-breadcrumb>
<div class="card">
  <div class="card-header bg-primary">
    <h5 class="text-uppercase text-white">Listado de Exámenes Médicos</h5>
  </div>

  <div class="card-body custom-datatable noscroll">
    
    
    <div class="custom-datatable table-responsive">
      <table class="table table-hover table-bordered" id="tblMedicos">
        <thead class="bg-primary">
          <tr>
            <th class="text-center" (click)="sortData('cedula')" style="cursor: pointer;">CEDULA</th>
            <th class="text-center" (click)="sortData('primernombre')" style="cursor: pointer;">NOMBRES Y APELLIDOS</th>
            <th class="text-center" (click)="sortData('fecha')" style="cursor: pointer;">FECHA</th>
            <th class="text-center" (click)="sortData('vence')" style="cursor: pointer;">VENCE</th>
            <th class="text-center" (click)="sortData('entidad')" style="cursor: pointer;">ENTIDAD</th>
            <th class="text-center" (click)="sortData('estado')" style="cursor: pointer;">ESTADO</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let examen of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }; let i = index">
            <td class="text-center">{{ examen.cedula }}</td>
            <td class="text-center text-uppercase">
              {{ examen.propietario?.primernombre }}
              {{ examen.propietario?.segundonombre }}
              {{ examen.propietario?.papellidos }}
              {{ examen.propietario?.seapellidos }}</td>
            <td class="text-center">{{ examen.fecha | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ examen.vence | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ examen.entidad }}</td>
            <td class="text-center">
              <span class="badge" [ngClass]="{
                'bg-success': examen.estado === 'Vigente',
                'bg-warning': examen.estado === 'Por vencer',
                'bg-danger': examen.estado === 'Vencido'
              }">
                {{ examen.estado }}
              </span>
            </td>
          </tr>
        </tbody>
        
      </table>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <!-- Selector de registros por página alineado a la izquierda -->
        <div class="d-flex align-items-center">
          <label for="pageSize1" class="me-2">Mostrar:</label>
          <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
            <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>
      
         <!-- Mostrar cantidad total de registros centrado -->
         <div class="text-center flex-grow-1">
          Total Registros:        
          <a class="badge badge-primary"><b>{{ examenes?.length || 0 }}</b></a>
        </div>
        

        <!-- Paginador alineado a la derecha -->
        <div class="text-end paginador-personalizado">
          <pagination-controls 
          (pageChange)="page1 = $event" 
          [maxSize]="5" 
          [directionLinks]="true" 
          [autoHide]="true"
          previousLabel="Anterior" 
          nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblMultas', 'Listado_Multas')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblMultas',
              'Listado_Multas',
              'Listado de Multas'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="col-xl-12 col-sm-12">
    <app-graficos></app-graficos>
  </div>
</div>











  